import React, { useCallback } from "react";
import styles from "./LectureItem.module.css";
import { useTranslation } from "react-i18next";
import { deleteLecture } from "../../../redux/actions/courses";
import { useDispatch } from "react-redux";
import { deleteQuiz } from "../../../redux/actions/quiz";

const LectureItem = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const lectureIcon =
    props.fileType === "video"
      ? "Video.svg"
      : props.fileType === "pdf"
      ? "article-(teacher).svg"
      : props.fileType === "live"
      ? "live-session.svg"
      : props.fileType === "quiz"
      ? "quiz.svg"
      : "assignment-(teacher).svg";

  const handleDelete = useCallback(async () => {
      if (props.isEditing) return;

      try {
        if (props.fileType === "quiz") {
          await dispatch(deleteQuiz(props.lectureID));
        } else {
          await dispatch(deleteLecture(props.sectionID, props.lectureID));
        }
        props.onDelete?.(props.sectionID, props.lectureID, props.fileType);
      } catch (err) {
        console.error("Delete failed:", err);
      }
    }, [
      dispatch,
      props.isEditing,
      props.fileType,
      props.sectionID,
      props.lectureID,
      props.onDelete,
    ]);

  return (
    <div className={styles.main}>
      <div className={styles.lecture_title}>
        <div className={styles.lecture_first_name}>
          {`${props.fileType == "quiz" ? t("quiz.quiz") : t("common.lecture")} ${
            props.index + 1
          }: `}
        </div>
        <div className={styles.lecture_last_name}>
          <img src={`/Image/lecturePlan/${lectureIcon}`} alt={`${props.fileType} icon`} />
          <span>{props.title}</span>
        </div>
      </div>

      <div className={props.isEditing ? styles.icons_disabled : styles.icons}>
        {/* {props.fileType !== "quiz" && (
          <img
            src={`/Image/lecturePlan/${props.isEditing ? "Edit-grey" : "Edit"}.svg`}
            onClick={props.isEditing ? null : ()=> props.onEdit(props.sectionID ,props.lecture)}
          />
        )} */}
        <img
          src={`/Image/lecturePlan/${props.isEditing ? "delete-bin-grey" : "delete-bin"}.svg`}
          onClick={handleDelete}
          role="button"
          aria-disabled={props.isEditing}
        />
      </div>
    </div>
  );
};

export default LectureItem;